import { VStack } from '@chakra-ui/react';

const Stats = () => {
  return <VStack>🚧 under construction 🚧</VStack>;
};

export default Stats;
